import React from "react";

/** Options passed by PrimeReact `DataTable` / `Paginator` to custom link renderers */
export type DataTablePaginatorLinkOptions = {
  className: string | undefined;
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  disabled: boolean | undefined;
};

const iconButtonStyle: React.CSSProperties = {
  minWidth: "2.75rem",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

const iconStyle: React.CSSProperties = { fontSize: "1.15rem", lineHeight: 1 };

/** Icon-only nav control (labels via `aria-label` for screen readers). */
const iconNavLink =
  (ariaLabel: string, iconClass: string) => (o: DataTablePaginatorLinkOptions) => (
    <button
      type="button"
      className={o.className}
      onClick={o.onClick}
      disabled={o.disabled}
      aria-label={ariaLabel}
      style={iconButtonStyle}
    >
      <i className={`pi ${iconClass}`} style={iconStyle} aria-hidden />
    </button>
  );

/**
 * Default DataTable paginator: first / previous / page numbers / next / last (icons only).
 * Used across list views, pinned tables, asset summary, and sidebars.
 */
export const dataTablePaginatorTemplate = {
  layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
  FirstPageLink: iconNavLink("First page", "pi-angle-double-left"),
  PrevPageLink: iconNavLink("Previous page", "pi-angle-left"),
  NextPageLink: iconNavLink("Next page", "pi-angle-right"),
  LastPageLink: iconNavLink("Last page", "pi-angle-double-right"),
};

/** @alias — same as {@link dataTablePaginatorTemplate} (kept for existing imports e.g. voluntary ListView). */
export const dataTablePaginatorTemplateWithFirstLast = dataTablePaginatorTemplate;

/** @alias — survey sidebars use the same controls as main tables. */
export const dataTablePaginatorTemplateSidebar = dataTablePaginatorTemplate;
